export default "__VITE_ASSET__14_e6YVe__"